import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export default class CropService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    getAll() {
        return this.axios
            .get(this.route('api.crops.index'))
            .then((response) => response.data.data);
    }
    getAllVarieties(cropId) {
        return this.axios
            .get(this.route('api.crops.varieties.index', { crop: cropId }))
            .then((response) => response.data.data);
    }
}
